module.exports = __webpack_public_path__ + "img/Back Headlight.5973f43a.png";